module.exports = __webpack_public_path__ + "img/04.9029f4d0.jpg";